// AMC ขาย HOS (TO-HOUSING) — status 7 (ภายใน) / 8 (ภาษี) ของโปรแกรม AMC
// ชื่อรหัส block_code เป็นสัญญากับ backend ห้ามเปลี่ยน

export const BLOCK_CODES = {
  MISSING_INTERNAL_COST: {
    book: "เล่มภายใน",
    short: "ยังไม่มีต้นทุนโฉนด",
    tell: "ยังไม่ได้บันทึกต้นทุนของโฉนดนี้ ให้บันทึกต้นทุนรายโฉนดในระบบ AMC ก่อน แล้วโหลดรายการใหม่",
  },
  MISSING_MORTGAGE_FEE: {
    book: "เล่มภายใน",
    short: "ยังไม่มีค่าโอนสิทธิ์",
    tell: "ยังไม่ได้บันทึกค่าโอนสิทธิ์การจำนองของโฉนดนี้ ให้บันทึกค่าโอนรายโฉนดในระบบ AMC ก่อน แล้วโหลดรายการใหม่",
  },
  MORTGAGE_FEE_UNCLEARED: {
    book: "เล่มภายใน",
    short: "ค่าโอนยังไม่เคลียร์",
    tell: "ค่าโอนสิทธิ์ของโฉนดนี้ยังไม่ได้เคลียร์ยอด ให้เคลียร์รายการค่าโอนก่อน แล้วโหลดรายการใหม่",
  },
  MORTGAGE_FEE_NEGATIVE: {
    book: "เล่มภายใน",
    short: "ค่าโอนติดลบ",
    tell: "ยอดค่าโอนสิทธิ์ของโฉนดนี้ติดลบ ให้ตรวจรายการค่าโอนในระบบ AMC",
  },
  BILL_AMOUNT_ZERO: {
    book: "เล่มภาษี",
    short: "บิลรับเงินเป็น 0",
    tell: "บิลรับเงินของใบขายนี้ยอดเป็น 0 ให้แก้ราคาขายและบิลรับเงินในระบบ AMC ก่อน",
  },
  BILL_AMOUNT_MISMATCH: {
    book: "เล่มภาษี",
    short: "ยอดบิลไม่ตรงราคาขาย",
    tell: "ยอดบิลรับเงินไม่ตรงกับราคาขาย ให้ตรวจว่ายอดไหนถูกแล้วแก้ให้ตรงกันในระบบ AMC",
  },
  TAX_SPLIT_FAILED: {
    book: "เล่มภาษี",
    short: "แบ่งเงินบิลไม่ได้",
    tell: 'แบ่งเงินบิลให้แต่ละโฉนดไม่ได้ ให้ตรวจมูลค่าทรัพย์ของทุกโฉนดในใบขายนี้ (ถ้าข้อความบอก "ลองใหม่" ให้โหลดรายการใหม่แล้วกดอีกครั้ง)',
  },
  UNKNOWN_PAYTYP: {
    book: "เล่มภาษี",
    short: "ช่องทางรับเงินยังไม่รองรับ",
    tell: "ช่องทางรับเงินของบิลนี้ยังไม่มีผังบัญชี ให้แจ้งฝ่ายบัญชีกำหนดบัญชี แล้วแจ้งทีม IT เพิ่มในระบบ",
  },
};

// รหัสไม่รู้จัก → "ลงไม่ได้"
export const blockLabel = (code) => BLOCK_CODES[code]?.short || "ลงไม่ได้";
export const blockTell = (code) => BLOCK_CODES[code]?.tell;

export const isToHousing = (program, status) =>
  program === 2 && (status === 7 || status === 8);

export const isRejectAll = (res) =>
  res?.failed > 0 &&
  res.failed === res.total &&
  String(res.message ?? "").includes("ยกเลิกทั้งชุด");

// true = ต้องหยุดลูป sync ทันที
export const shouldStopSync = (res) =>
  !!res?.halted || isRejectAll(res) || (res?.total ?? 0) === 0;

// รวมผล sync หลายรอบ → { tone, title, lines[], failedRecords, halted }
// tone: ok | warn | info | bad | grey
export const summarizeSync = (results) => {
  const failedRecords = results.flatMap((r, i) =>
    (r?.failed_records ?? []).map((f) => ({ ...f, round: i + 1 })),
  );

  const haltedRes = results.find((r) => r?.halted);
  if (haltedRes) {
    const success = results.reduce((s, r) => s + (r?.success ?? 0), 0);
    return {
      tone: "bad",
      halted: true,
      title: "⛔ หยุดกลางคัน — ห้ามกดซ้ำ ให้แจ้งทีม IT ตรวจฐานข้อมูลก่อน",
      lines: [
        `ลงแล้ว ${success} · ไม่แน่ใจสถานะ ${haltedRes.failed ?? 0} · ยังไม่ได้ทำ ${haltedRes.not_attempted ?? 0}`,
        haltedRes.message,
      ],
      failedRecords,
    };
  }

  const rejectRes = results.find(isRejectAll);
  if (rejectRes) {
    return {
      tone: "bad",
      title: "⛔ ระบบปฏิเสธทั้งชุด — ยังไม่มีอะไรลง",
      lines: [
        "ฐานข้อมูลเล่มภาษีตั้งค่าไม่ถูกต้อง ให้แจ้งทีม IT ทันที อย่ากดซ้ำ",
        rejectRes.message,
      ],
      failedRecords,
    };
  }

  const sum = (k) => results.reduce((s, r) => s + (r?.[k] ?? 0), 0);
  const total = sum("total");
  const success = sum("success");
  const skipped = sum("skipped");
  const pending = sum("pending");
  const failed = sum("failed");

  if (total === 0) {
    return {
      tone: "grey",
      title: "ไม่มีรายการให้ลง",
      lines: ["รายการที่เลือกอาจลงไปแล้ว หรือไม่อยู่ในคิวนี้ — โหลดรายการใหม่"],
      failedRecords,
    };
  }

  const pendingRecords = results.flatMap((r) => r?.pending_records ?? []);
  const lines = [];
  if (success) lines.push(`✅ ลงบัญชีสำเร็จ ${success} โฉนด`);
  if (skipped)
    lines.push(`ℹ️ ${skipped} โฉนดมีเอกสาร GL อยู่แล้ว ระบบไม่ลงซ้ำ`);
  if (pending)
    lines.push(
      `⚠️ ยังไม่ลง ${pending} โฉนด (ข้อมูลต้นทางไม่ครบ)${
        pendingRecords.length ? `: ${pendingRecords.join(", ")}` : ""
      }`,
    );
  if (failed)
    lines.push(
      `❌ error ${failed} โฉนด — กดลงใหม่ได้ ระบบไม่ลงซ้ำ ถ้ายัง error ให้แจ้งทีม IT พร้อมข้อความนี้`,
    );

  const tone = failed ? "bad" : pending ? "warn" : success ? "ok" : "info";
  return {
    tone,
    title:
      tone === "ok"
        ? `✅ ลงบัญชีสำเร็จ ${success} โฉนด`
        : tone === "info"
          ? `ℹ️ ${skipped} โฉนดมีเอกสาร GL อยู่แล้ว ระบบไม่ลงซ้ำ`
          : "ลงบัญชีเสร็จ (มีบางรายการต้องดู)",
    // มีบรรทัดเดียวก็ซ้ำกับ title แล้ว
    lines: lines.length > 1 || tone === "bad" || tone === "warn" ? lines : [],
    failedRecords,
  };
};

// HTTP ที่ไม่ใช่ 200 — body เป็น text/plain
export const httpErrorText = (err) => {
  const data = err?.response?.data;
  const body =
    typeof data === "string" ? data.trim() : data?.message || err?.message;
  switch (err?.response?.status) {
    case 401:
      return "ไม่มีสิทธิ์เรียกระบบบัญชี (API key ไม่ถูกต้อง)";
    case 400:
      return `ช่วงวันที่ไม่ถูกต้อง${body ? `: ${body}` : ""}`;
    case 405:
      return `เรียก API ผิด method (บั๊กฝั่งหน้าบ้าน)${body ? `: ${body}` : ""}`;
    case 500:
      return `ระบบขัดข้อง ยังไม่ได้ลงบัญชี ลองใหม่อีกครั้ง ถ้ายังไม่ได้ให้แจ้งทีม IT${
        body ? ` — ${body}` : ""
      }`;
    default:
      return body || "ไม่สามารถเชื่อมต่อระบบบัญชีได้";
  }
};

// สี antd Alert ตาม tone
export const TONE_ALERT_TYPE = {
  ok: "success",
  warn: "warning",
  info: "info",
  bad: "error",
  grey: "info",
};
